export const DEFAULT_SUBMENU_WIDTH = 220;

export type SubmenuHorizontalSide = 'left' | 'right';

export const getSubmenuHorizontalSide = (
    anchor: Pick<DOMRect, 'left' | 'right'>,
    submenuWidth: number = DEFAULT_SUBMENU_WIDTH,
    viewportWidth: number = typeof window !== 'undefined' ? window.innerWidth : submenuWidth
): SubmenuHorizontalSide => {
    const spaceRight = viewportWidth - anchor.right;
    const spaceLeft = anchor.left;

    if (spaceRight >= submenuWidth) {
        return 'right';
    }
    if (spaceLeft >= submenuWidth) {
        return 'left';
    }
    return spaceLeft > spaceRight ? 'left' : 'right';
};
